// extracted by mini-css-extract-plugin
export default {"product":"Product-module--product--b9882","register":"Product-module--register--38c72","ownership":"Product-module--ownership--1ad97"};